import { action, observable } from "mobx";
import { ModelBase } from "@shoothill/core";

export class InductionAdminNearMissModel extends ModelBase<InductionAdminNearMissModel, any> {
    // #region Constructors and Disposers
    // #endregion Constructors and Disposers

    // #region Constants and Defaults

    public static readonly DEFAULT_ID = null;
    public static readonly DEFAULT_PROJECT_ID = "";
    public static readonly DEFAULT_INCIDENT_NUMBER = null;
    public static readonly DEFAULT_IS_DELETED = false;
    public static readonly DEFAULT_CREATED_BY_USER_ID = null;
    public static readonly DEFAULT_CREATED_DATE = null;
    public static readonly DEFAULT_ROW_VERSION = null;
    public static readonly DEFAULT_LAST_UPDATED_BY_USER_ID = null;
    public static readonly DEFAULT_LAST_UPDATED_DATE = null;

    // #endregion Constants and Defaults

    // #region Properties

    @observable
    public id: string | null = InductionAdminNearMissModel.DEFAULT_ID;

    @observable
    public projectId: string = InductionAdminNearMissModel.DEFAULT_PROJECT_ID;

    @observable
    public incidentNumber: number | null = InductionAdminNearMissModel.DEFAULT_INCIDENT_NUMBER;

    @observable
    public isDeleted: boolean = InductionAdminNearMissModel.DEFAULT_IS_DELETED;

    @observable
    public createdByUserId: number | null = InductionAdminNearMissModel.DEFAULT_CREATED_BY_USER_ID;

    @observable
    public createdDate: string | null = InductionAdminNearMissModel.DEFAULT_CREATED_DATE;

    @observable
    public rowVersion: string | null = InductionAdminNearMissModel.DEFAULT_ROW_VERSION;

    @observable
    public lastUpdatedByUserId: number | null = InductionAdminNearMissModel.DEFAULT_LAST_UPDATED_BY_USER_ID;

    @observable
    public lastUpdatedDate: string | null = InductionAdminNearMissModel.DEFAULT_LAST_UPDATED_DATE;

    // #endregion Properties

    // #endregion Properties

    // #region Actions

    @action
    public reset = () => {
        this.id = InductionAdminNearMissModel.DEFAULT_ID;
        this.projectId = InductionAdminNearMissModel.DEFAULT_PROJECT_ID;
        this.incidentNumber = InductionAdminNearMissModel.DEFAULT_INCIDENT_NUMBER;
        this.isDeleted = InductionAdminNearMissModel.DEFAULT_IS_DELETED;
        this.createdByUserId = InductionAdminNearMissModel.DEFAULT_CREATED_BY_USER_ID;
        this.createdDate = InductionAdminNearMissModel.DEFAULT_CREATED_DATE;
        this.rowVersion = InductionAdminNearMissModel.DEFAULT_ROW_VERSION;
        this.lastUpdatedByUserId = InductionAdminNearMissModel.DEFAULT_LAST_UPDATED_BY_USER_ID;
        this.lastUpdatedDate = InductionAdminNearMissModel.DEFAULT_LAST_UPDATED_DATE;
    };

    @action
    public fromDto(dto: InductionAdminNearMissAndRelatedResponseDTO): void {
        //const incidentDto = dto.incident;
        // for (let key in incidentDto) {
        //     if (incidentDto.hasOwnProperty(key)) {
        //         if (this[key] instanceof Date) {
        //             this[key] = new Date(incidentDto[key]);
        //         } else {
        //             this[key] = incidentDto[key];
        //         }
        //     }
        // }
    }

    public toDto() {
        throw new Error("Method not implemented.");
    }

    // #endregion Actions

    // #region Custom Validation

    // #endregion Custom Validation
}

export interface InductionAdminNearMissDTO {
    id: string | null;
    projectId: string;
    incidentNumber: number | null;
    isDeleted: boolean;
    createdByUserId: number | null;
    createdDate: string | null;
    rowVersion: string | null;
    lastUpdatedByUserId: number | null;
    lastUpdatedDate: string | null;
}

export interface InductionAdminNearMissAndRelatedResponseDTO {
    //incident: InductionAdminNearMissDTO;
    incidentFormTypes: IncidentFormTypeDTO[];
    incidentFormListItems: InductionAdminNearMissItemDTO[];
    //incidentProjectDetails: IncidentProjectDetailsDTO;
}

export interface IncidentProjectDetailsDTO {
    projectReference: string;
    projectName: string;
}

export interface IncidentFormTypeDTO {
    id: string;
    displayName: string;
    type: number;
    ordinal: number;
    isDeleted: boolean;
}

export interface InductionAdminNearMissItemDTO {
    id: string;
    incidentFormTypeName: string;
    incidentFormType: number;
    location: number;
    isInvestigationReportAdded: string;
    lastUpdatedDate: boolean;
    lastUpdatedByUserName: string;
    createdDate: string;
    projectId: string;
    incidentId: string;
}

export interface IncidentProjectDetailsDTO {
    projectReference: string;
    projectName: string;
}
